import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Select, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventDto, SourcingEventPatchDto } from "../../../../../autogen/bff-api";
import { useEditor, useFieldErrorTranslation } from "../../../../../common/editing/save-coordinator";
import { NORWEGIAN_COUNTIES, countyName } from "../../../../../common/procurement/norwegianCounties";

const NORWAY_ALPHA3 = "NOR";
const PLACE_OF_PERFORMANCE = "eventData.placeOfPerformance";

export const PlaceOfPerformanceField = ({ eventId }: { eventId: string }) => {
  const { t } = useTranslation();
  const { state, updateField, fieldStatus, fieldError } = useEditor<SourcingEventDto, SourcingEventPatchDto>(eventId);
  const formatFieldError = useFieldErrorTranslation();
  const county = state.eventData.placeOfPerformance?.countrySubdivision ?? "";
  const addressCounty = countyName(state.derivedCountySubdivision);
  const status = fieldStatus(PLACE_OF_PERFORMANCE);
  const isSaving = status === "saving" || status === "pending";
  const error = fieldError(PLACE_OF_PERFORMANCE);

  return (
    <FormControl mb="8" isInvalid={!!error}>
      <FormLabel htmlFor="place-of-performance">
        {t("Place of performance")} {isSaving && <Spinner size="xs" />}
      </FormLabel>
      <Select
        id="place-of-performance"
        maxW="sm"
        value={county}
        onChange={(event) =>
          updateField({
            eventData: {
              placeOfPerformance: event.target.value
                ? { countryCode: NORWAY_ALPHA3, countrySubdivision: event.target.value }
                : null,
            },
          })
        }
      >
        <option value="">
          {addressCounty
            ? t("The county of your organisation's address ({{county}})", { county: addressCounty })
            : t("The county of your organisation's address")}
        </option>
        {NORWEGIAN_COUNTIES.map((option) => (
          <option key={option.code} value={option.code}>
            {option.name}
          </option>
        ))}
      </Select>
      <FormHelperText color="smMuted">
        {t("The county where the contract is performed. It is stated in the notice on Doffin.")}
      </FormHelperText>
      {error && <FormErrorMessage>{formatFieldError(error)}</FormErrorMessage>}
    </FormControl>
  );
};
